/*
Generate a new screen handler
@class ScreenHandler
@constructor
@namespace collections.screenHandler
@param {JQuery} the div to register the message queue
@param {integer} the ID of the initial theme
@param {integer} the ID of the initial master
@param {integer} the ID of wich navigation is shown
@return {Object} an instance of the screen handler object */
function ScreenHandlerFavorites() {
    this.source = "ScreenHandlerFavorites";
}
ScreenHandlerFavorites.prototype = new window.vcTemplate();
ScreenHandlerFavorites.prototype.init = function (globalsDIV, themeID, masterID, navigationID) {
    var me = this;
    try {////STANDARD-VARIABLES:= NEEDED!!!

        me.setMaster(masterID);
        me.setTheme(themeID);
        window._VCMQ.addConsumer('COLLMQ');
        window._VCMQ.consume(globalsDIV, 'COLLMQ', function (event) { me.events(event); });
        me.themeID = themeID;
        me.masterID = masterID;
        me.pause = false;
        me.preloadPadding = 2;
        me.indicatorString = "circle-outline";
        me.runningPreview = false;
        ////EDIT TO YOUR NEED; BUT DONT DELETE!
        if (parseInt(globalsDIV.height(),10) <= 840) {
            me.chartTheme = 1;
        } else {
            me.chartTheme = 2;
        }
        ////OWN-VARIABLES:= DO WHAT EVER YOU LIKE!
        me.wwHighlightColor = ' #3e3d40';
        me.wwColor = ' #749513';
        me.wwBGColor = ' #fff';
        me.wwHorizontal = true;
        me.border = '0px solid #fff';

        me.SubMode = 1; //0..OFF 1..power heat 2..daily usage 3..Daily Usage accumulated 4..Difference

        if (navigationID > 1) {
            me.bNavigation = true;
        } else {
            me.bNavigation = false;
        }
    } catch (ex) {
        me.writeError(me.source + ".init", ex);
    }
};

ScreenHandlerFavorites.prototype.setTheme = function (theme) {
    var me = this;
    try {
        if (theme) {
            me.themeID = theme.toString();
        }
        $("#streamColorStyle").attr("href", "../../App_Themes/Bluaul/collections/color/color" + me.themeID + "/color" + me.themeID + ".min.css");
    } catch (ex) {
        me.writeError(me.source + ".setTheme", ex);
    }
};

ScreenHandlerFavorites.prototype.setMaster = function (master) {
    var me = this;
    try {
        if (master) {
            me.masterID = master.toString();
        }
        if (parseInt(master,10) === 2 || parseInt(master,10) === 5 || parseInt(master) === 7) {
            me.wwHorizontal = false;
        } else {
            me.wwHorizontal = true;
        }
        var url = "../../App_Themes/Bluaul/collections/master/master" + me.masterID + "/master" + me.masterID + ".min.css";
        var link = $("#streamMasterStyle");
        link.attr("href", url);

        var img = document.createElement('img');
        //img.onerror = function() {
        //    me.loadWidgets();
        //};
        img.src = url;

        me.loadWidgets();
    } catch (ex) {
        me.writeError(me.source + ".setMaster", ex);
    }

};


ScreenHandlerFavorites.prototype.setNavigation = function () {
    /// Sets the navigation mehtod and the keyListener if needed.
/// 0..no navigation at all
/// 1..show List
    var me = this;
    try {
        var i = 0,
            j = 0,
            index = 0,
            sTmp = "";
        me.addKeyDownListener();
        window._collection.nav = 4;
        switch (window._collection.nav) {
            case 0: //old school bluaul tv
                $("#navigation").css("display", "none");
                break;
            case 1: // standard navigation for tv
                sTmp = "";
                for (i = 0; i < window._collection.playlist.length; i++) {
                    if (window._collection.playlist[i].active) {
                        j = i + 1;
                        sTmp += "<span id='menu" + i + "' class='navi'>" + j + ': ' + window._collection.playlist[i].name + '</span><br/>';
                    }
                }
                sTmp += "<span id='menuPause' class='pause'>P: Pause</span>";

                $("#navigation").html(sTmp);
                $("#menu" + window._collection.index).css("font-weight", "bold");
                $(".navi").css("cursor", "pointer");
                $(".pause").css("cursor", "pointer");

                $(".pause").click(function () {
                    me.togglePause(window._collection);
                    return false;
                });

                $(".navi").click(function () {
                    if (me.pause) {
                        me.togglePause(window._collection);
                    }
                    clearTimeout(window._collection.timer);
                    index = $(this).attr("id");
                    index = index.substring(4, index.length);

                    window._collection.index = parseInt(index, 10) - 1; //-1 is required because CHANGEENTRY adds +1 automatically :)
                    window._VCMQ.produce(window._collection.globalsDIV, 'COLLMQ', 'CHANGEENTRY');

                    $(".navi").css("font-weight", "normal");
                    $("#menu" + window._collection.index).css("font-weight", "bold");
                }).css("cursor", "pointer");
                break;

            case 2: //half transparent list of entries, currently mainly for debug
                sTmp = "";
                $("#navigation").css("padding", "5px");
                for (i = 0; i < window._collection.playlist.length; i++) {
                    if (window._collection.playlist[i].active) {
                        sTmp += "<div id='menu" + i + "' class='navi round frame' style='width:90%; margin:5px; height:35px;background-color:#97bf0d;padding-top:20px; text-align:center; vertical-align:middle '>" + i + ': ' + window._collection.playlist[i].name + '</div>';
                    }
                }

                $("#navigation").html(sTmp);
                $(".navi").css("cursor", "pointer");

                $(".navi").click(function () {
                    clearTimeout(window._collection.timer);
                    index = $(this).attr("id");
                    index = index.substring(4, index.length);
                    window._collection.index = parseInt(index, 10) - 1; //-1 is required because CHANGEENTRY adds +1 automatically :)
                    window._VCMQ.produce(window._collection.globalsDIV, 'COLLMQ', 'CHANGEENTRY');

                    $(".navi").css("font-weight", "normal");
                    $("#menu" + window._collection.index).css("font-weight", "bold");
                }).css("cursor", "pointer");
                break;

            case 3: //left and right arrows, only prototype not in use
                sTmp = "";
                sTmp += "<div id='menu_prev' class='navi round frame' style='width:90%; margin:" + window._collection.getRelativeHeight(10) + "px " + window._collection.getRelativeHeight(10) + "px " + window._collection.getRelativeHeight(20) + "px " + window._collection.getRelativeHeight(5) + "px; height:" + window._collection.getRelativeHeight(270) + "px;background-color:#004b79; border:6px solid #888;padding-top:" + window._collection.getRelativeHeight(20) + "px; text-align:center; vertical-align:middle '>";
                sTmp += "<img src='../../images/visualcore/arrow_left.gif' style='width:" + window._collection.getRelativeHeight(150) + "px; margin-top:" + window._collection.getRelativeHeight(35) + "px' />";
                sTmp += "</div>";
                sTmp += "<div id='menu_run' class='navi round frame' style='width:90%; margin:" + window._collection.getRelativeHeight(10) + "px " + window._collection.getRelativeHeight(10) + "px " + window._collection.getRelativeHeight(20) + "px " + window._collection.getRelativeHeight(5) + "px; height:" + window._collection.getRelativeHeight(270) + "px;background-color:#97bf0d;border:6px solid #888;padding-top:" + window._collection.getRelativeHeight(20) + "px; text-align:center; vertical-align:middle '>";
                sTmp += "pause";
                sTmp += "</div>";
                sTmp += "<div id='menu_next' class='navi round frame' style='width:90%;margin:" + window._collection.getRelativeHeight(10) + "px " + window._collection.getRelativeHeight(10) + "px " + window._collection.getRelativeHeight(20) + "px " + window._collection.getRelativeHeight(5) + "px; height:" + window._collection.getRelativeHeight(270) + "px;background-color:#004b79;border:6px solid #888;padding-top:" + window._collection.getRelativeHeight(20) + "px; text-align:center; vertical-align:middle '>";
                sTmp += "<img src='../../images/visualcore/arrow_right.gif' style='width:" + window._collection.getRelativeHeight(150) + "px; margin-top:" + window._collection.getRelativeHeight(35) + "px' />";
                sTmp += "</div>";

                $("#navigation").html(sTmp);
                $(".navi").css("cursor", "pointer");

                $("#menu_prev").click(function () {
                    clearTimeout(window._collection.timer);
                    if (window._collection.index === 0) {
                        index = window._collection.playlist.length - 2;
                    } else {
                        index = window._collection.index - 1;
                    }
                    window._collection.index = parseInt(index, 10) - 1; //-1 is required because CHANGEENTRY adds +1 automatically :)
                    window._VCMQ.produce(window._collection.globalsDIV, 'COLLMQ', 'CHANGEENTRY');
                    $("#menu_run").html("pause").css("background-color", "#97bf0d");
                });

                $("#menu_next").click(function () {
                    clearTimeout(window._collection.timer);
                    if (window._collection.playlist.length - 2 < window._collection.index) {
                        index = 0;
                    } else {
                        index = window._collection.index + 1;
                    }
                    window._collection.index = parseInt(index, 10) - 1; //-1 is required because CHANGEENTRY adds +1 automatically :)
                    window._VCMQ.produce(window._collection.globalsDIV, 'COLLMQ', 'CHANGEENTRY');
                    $("#menu_run").html("pause").css("background-color", "#97bf0d");
                });

                $("#menu_run").click(function () {
                    $("#menu_run").html("play").css("background-color", "#ec0002");
                    clearTimeout(window._collection.timer);
                });
                break;
            case 4: // Indicators
                if ($(window._collection.globalsDIV.selector).height() < 300) {
                    me.fontSize = 20;
                    me.topHalf = 1;
                } else {
                    me.fontSize = 30;
                    me.topHalf = 0.1;
                }

                //$("#page_indicators").css("font-size", me.fontSize + "px");
                if (window._collection.playlist.length > 1) {
                    //halbe länge des max platzes - font-size + margin-left * anzahl der marker

                   sTmp = "<div id='page_indicators_sub'><div id='divIndicator_0' class='indicators'></div>";
                    for (j = 1; j <= window._collection.playlist.length - 1; j++) {
                        sTmp += "<div id='divIndicator_" + j + "' class='indicators'></div>";
                    }
                    sTmp += "</div>";
                    $("#page_indicators").html(sTmp);
                    $(".indicators").click(function () {
                        if (me.pause) { me.togglePause(window._collection); }
                        clearTimeout(window._collection.timer);
                        var index = $(this).attr("id");
                        index = index.substring(13, index.length);
                        window._collection.index = parseInt(index, 10) - 1; //-1 is required because CHANGEENTRY adds +1 automatically :)
                        window._VCMQ.produce(window._collection.globalsDIV, 'COLLMQ', 'CHANGEENTRY');
                    }).css("cursor", "pointer");
                }
                break;
        }
        //$("#navigation").css("display", "block");
    } catch (ex) {
        me.writeError(me.source + "setNavigation", ex);
    }
};


ScreenHandlerFavorites.prototype.generateDivs = function () {
    var me = this;
    var pageNumbers = "";
    try {
        if (window._collection.globalsDIV.find("#bec_logo").length === 0) {
            if (me.runningPreview) {
                pageNumbers = me.resources.collDivPageNumbers_lbl;
            }
           
            var s = " <div id='page_title_text' >";
            s += "  <div id='page_title'               >" + me.resources.collDivPageTitle_lbl + "</div>";
            s += "  <div id='page_subtitle'             >" + me.resources.collDivPageSubTitle_lbl + "</div>";
            s += "</div>";

            s += "<div id='client_logo' class='round'><div class='collEle'>" + me.resources.collDivClientLogo_lbl + "</div></div>";
            s += "<div id='bec_logo' ></div>";
            s += " <div id='page_indicators' ><div class='collEle'>" + me.resources.collDivNavAndPageIndicators_lbl + "</div></div>";
            s += "<div id='page_numbers'>" + pageNumbers + "</div>";
            s += "<div id='navigation' ><div class='collEle'>" + me.resources.collDivNavAndPageIndicators_lbl + "</div></div>";
            s += "<div id='weather_main'><div class='collEle'>" + me.resources.collDivPageWeather_lbl + "</div></div>";
            //regex removes all uneccessary whitespace chars
            window._collection.globalsDIV.append(s.replace(/ +(?= )/g, ''));
        }
    } catch (ex) {
        me.writeError(me.source + ".generateDivs", ex);
    }
};


ScreenHandlerFavorites.prototype.loadWidgets = function () {
    var me = this;
    try {
        var widget;
        me.wwBGColor = $(window._collection.cm).css("background-color");
        me.wwColor = " black";
        me.wwHighlightColor = $("#page_title").css("color");
        widget = new window.Widget("weather_",
            'WIDGET_WEATHER',
            "main",
            $("#weather_main"),
            '{"BackgroundColor":"' + me.wwBGColor + '", "Color":"' + me.wwColor + '", "HighlightColor":"' + me.wwHighlightColor + '", "Border":"' + me.border + '", "Horizontal":"' + me.wwHorizontal + '"}',
            1);
        if (widget.div.length === 1) {
            window._VCMQ.produce(window._collection.globalsDIV, 'COLLMQ', 'LOAD_SINGLEWIDGET', widget);
        }
        widget = new window.Widget("client_",
            "VISUAL_FILEVIEWER",
            'logo',
            $("#client_logo"),
            JSON.stringify({
                "mediaID": $("#globalCustLogo").html()
            }),
            1);
        if (widget.div.length === 1) {
            window._VCMQ.produce(window._collection.globalsDIV, 'COLLMQ', 'LOAD_SINGLEWIDGET', widget);
        }

    } catch (ex) {
        me.writeError(me.source + ".loadWidgets", ex);
    }
};

ScreenHandlerFavorites.prototype.setEntryMaster = function (collection) {
    var me = this;
    try {

        //window._VCMQ.produce(collection.globalsDIV, 'COLLMQ', 'HANDLER_SETMASTER', me.masterID); //setMaster(_master, true, false);
        $("#page_title").html(collection.playlist[collection.index].name);
        $("#page_subtitle").html(collection.playlist[collection.index].description);
    } catch (ex) {
        me.writeError(me.source + ".setEntryMaster", ex);
    }

};

ScreenHandlerFavorites.prototype.setEntryNav = function () {
    var me = this;
    try {
        $("#page_numbers").html(window._collection.index + 1 + " / " + window._collection.playlist.length);
        $(".navi").css("font-weight", "normal");
        $("#menu" + window._collection.index).css("font-weight", "bold");
        $(".indicators").html(window._collection.getIndicator(false, me.indicatorString));
        $("#divIndicator_" + window._collection.index).html(window._collection.getIndicator(true, me.indicatorString));
    } catch (ex) {
        me.writeError(me.source + ".setEntryNav", ex);
    }
};


ScreenHandlerFavorites.prototype.setLoading = function () {
    var me = this;
    try {
        var s = "<div id='divLoad' style='margin-top:5%;'>";
        s += "  <i class='fas fa-spinner fa-spin loadingIcon'></i>";
        s += "</div>";
        $(window._collection.cm).prepend(s.replace(/ +(?= )/g, ''));

        $(".loadingIcon").css("font-size", "35em");
        $(".loadingText").css("font-size", "8em");
        $("#divLoad").css("color", "#3e3d40").css("text-align", "center").css("margin-top", "5%");
        $("#divLoad").fadeTo(1500, 0.4, function () { $("#divLoad").fadeTo(3000, 0.7, function () { $("#divLoad").fadeTo(5000, 0.4); }); });
    } catch (ex) {
        me.writeError(me.source + ".setLoading", ex);
    }
};

ScreenHandlerFavorites.prototype.addKeyDownListener = function () {
    var me = this,
        key = null;
    try {
        $(document).keydown(function (e) {
            key = e.keyCode || e.which;

            //"pause" space
            if (key === 32) {
                //Trigger pause when space (keycode 32) is pressed!
                me.togglePause(window._collection);
                return false;
            }

            //"next" > right arrow||arrow down|| f8
            if (key === 39 || key === 40 || key === 119) {
                clearTimeout(window._collection.timer);
                me.pause = false;
                window._VCMQ.produce(window._collection.globalsDIV, 'COLLMQ', 'CHANGEENTRY');
                return false;
            }

            //"back" < left arrow||arrow up|| f7
            if (key === 37 || key === 38 || key === 118) {
                //Ich muss den index um 2 erniedrigen, da bei changeentry der index automatisch um 1 erhöht wird.
                if (window._collection.index > 0) {
                    //Nur wenn ich zurück gehen kann, sonst wird der index negativ
                    window._collection.index--;
                }
                window._collection.index--;
                clearTimeout(window._collection.timer);
                me.pause = false;
                window._VCMQ.produce(window._collection.globalsDIV, 'COLLMQ', 'CHANGEENTRY');
                return false;
            }
            return true;
        });
    } catch (ex) {
        me.writeError(me.source + ".addKeyDownListener", ex);
    }
};

ScreenHandlerFavorites.prototype.togglePause = function () {
    var me = this, a, i;
    try {
        if (me.pause === false) {
            clearTimeout(window._collection.timer);
            $(".pause").css("font-weight", "bold");
            $("#menu" + window._collection.index).html($("#menu" + window._collection.index).html() + " *");
            $("#page_numbers").html($("#page_numbers").html() + " *");
            me.pause = true;
        } else {
            a = $("#menu" + window._collection.index).html();
            if (typeof a !== "undefined") {
                i = a.indexOf(" *");
                if (i > 0) {
                    a = a.substring(0, i);
                }
                $("#menu" + window._collection.index).html(a);
            }
            $("#page_numbers").html(window._collection.index + 1 + " / " + window._collection.playlist.length);
            $(".pause").css("font-weight", "normal");

            clearTimeout(window._collection.timer);
            window._VCMQ.produce(window._collection.globalsDIV, 'COLLMQ', 'RUN_PLAYLIST');
            me.pause = false;
        }
        return me.pause;
    } catch (ex) {
        me.writeError(me.source + ".togglePause", ex);
        return false;
    }
};


ScreenHandlerFavorites.prototype.events = function (event) {
    var me = this;
    try {
        switch (event.msg) {


        case "HANDLER_INIT":
            me.setMaster(event.values);
            me.setTheme();
            me.generateDivs();
            $("#page_title, #page_subtitle, #client_logo, #weather_main, #navigation, #content_sub, #content_main").html("");
                    me.loadWidgets();

            me.setLoading();
            $("#bec_logo").css({ "background-image": "url('" + $("#globalBecLogo").html() + "')" });

        if (me.SubMode > 0) {
                    window._VCMQ.produce(window._collection.globalsDIV, "COLLMQ", "START_SUB", me.SubMode);
                }
                break;

            case "HANDLER_SETMASTER":

                if (me.runningPreview) {

                    window._VCMQ.produce(window._collection.globalsDIVV, 'COLLMQ', 'HANDLER_INIT', event.values);
                } else {
                    me.setMaster(event.values);
                }
                break;
            case "HANDLER_SETPREV":
                me.generateDivs();
                me.setMaster(event.values);
                me.setTheme();
                $("#bec_logo").css({ "background-image": "url('" + $("#globalBecLogo").html() + "')" });

                break;
            case "HANDLER_SETTHEME":
                me.setTheme(event.values);
                break;

            case "HANDLER_SETNAVIGATION":
                me.setNavigation();
                break;

            case "HANDLER_SETENTRY_NAVIGATION":
                me.setEntryNav(event.values);
                break;

            case "HANDLER_SETENTRY_MASTER":
                me.setEntryMaster(event.values);
                break;


            default:
                break;
        }
    } catch (ex) {
        me.writeError(me.source + ".events", ex);
    }
};